import {action, computed, observable, runInAction} from 'mobx';
import _ from 'lodash'
import  api from './ReviewResponseTemplateAPI';


class ReviewResponseTemplateStore {
  @observable
  isLoading = false;

  @observable
  templates = [];

  @action.bound
  loadTemplates(force = false){
    if(!this.templates.length || force) {
      this.isLoading = true;
      return api.loadTemplates().then(templates =>
        runInAction(() => {
          this.isLoading = false;
          this.templates = templates;
          return this.templates;
        })
      );
    } else {
      return Promise.resolve(this.templates);
    }
  }

  @computed
  get groupedResponseTemplates() {
    return _.groupBy(this.templates, 'reviewSentimentType');
  }

}

export default ReviewResponseTemplateStore;